module.exports = __webpack_public_path__ + "static/media/mx.484c9c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mx.png
// module id = 1935
// module chunks = 0